<template>
  <section :id="galleryID" class="product-intro card">
    <h3 class="title">{{ $t('product_desc') }}</h3>
    <collapsible-article class="text-article my-4" :expand-btn-text="$t('all_show_all')" :max-height="400" :mask="true">
      <content-data v-for="(data, idx) in productIntro" :key="idx" v-bind="data"></content-data>
    </collapsible-article>
  </section>
</template>

<script setup lang="ts">
import CollapsibleArticle from '@/components/common/collapsible-article.vue'
import ContentData from '@/components/common/content-data.vue'

import type { UiProductInfo } from '@/types/product'

const props = defineProps<{
  product: UiProductInfo
}>()

const galleryID = 'product-intro'
const { lightboxInit } = useLightbox(galleryID)

const productIntro = computed(() =>
  (props.product?.product_intro || []).map(item => ({
    type: item.type,
    meta: item.meta,
    list: item.attr?.list || [],
    mediaWidth: item.attr?.width || 0,
    mediaHeight: item.attr?.height || 0,
  }))
)

onMounted(() => {
  lightboxInit()
})
</script>

<style lang="scss" scoped></style>
